export const LOCAL_STORAGE = {
  ID_TOKEN: 'idToken',
  LANG: 'lang'
}
